export default {
  wrapper: {
    viewTitle: "Wrapper",
    tabTitle: "Wrapper",
  },
};
